import React from 'react';
import style from './style.scss';
import {MyBusinessStatsContent} from './sub-view/stats-content';
import {BusinessLayout} from 'components/layouts/business';

class MyBusinessStatsContainer extends React.Component {
  constructor(props, context) {
    super(props, context);
  }

  render() {
    return (
      <BusinessLayout active="my-business-stats">
        <h1 className="user-header">Thống kê</h1>
        <MyBusinessStatsContent/>
      </BusinessLayout>
    );
  }
}

export default MyBusinessStatsContainer;



// WEBPACK FOOTER //
// ./components/my-business/MyBusinessStatsContainer.jsx